import { render, staticRenderFns } from "./article-map-form.vue?vue&type=template&id=c31576da"
import script from "./article-map-form.vue?vue&type=script&lang=js"
export * from "./article-map-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports